import { render, staticRenderFns } from "./CoinPresent.vue?vue&type=template&id=45ea8881&scoped=true&"
import script from "./CoinPresent.vue?vue&type=script&lang=js&"
export * from "./CoinPresent.vue?vue&type=script&lang=js&"
import style0 from "./CoinPresent.vue?vue&type=style&index=0&id=45ea8881&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ea8881",
  null
  
)

export default component.exports